import { Body } from "../body/Body";
import { Container, Props, getInitials } from "./Avatar.Parts";

export const Avatar = ({
  img,
  open,
  user,
  initials,
  height,
  width,
  interactive = true,
  ref,
  ...rest
}: Props) => {
  const _initials =
    initials ||
    (user?.firstName && user?.lastName
      ? getInitials(user.firstName, user.lastName)
      : undefined);

  return (
    <Container
      ref={ref}
      $img={img}
      $open={open}
      $height={height}
      $width={width}
      $interactive={interactive}
      tabIndex={interactive ? 0 : undefined}
      {...rest}
    >
      {!img && _initials && <Body>{_initials}</Body>}
    </Container>
  );
};
